import React from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	card: {
		padding: theme.spacing(2),
		height: "100%",
		display: "flex",
		flexDirection: "column",
		justifyContent: "space-between",
		minHeight: 112,
	},
	header: {
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "space-between",
	},
	label: {
		color: theme.palette.text.secondary,
		fontSize: "0.8125rem",
		fontWeight: 500,
	},
	info: {
		fontSize: 16,
		marginLeft: theme.spacing(0.5),
		color: theme.palette.text.disabled,
		cursor: "help",
	},
	value: {
		fontWeight: 600,
		lineHeight: 1.2,
		marginTop: theme.spacing(1),
	},
	caption: {
		color: theme.palette.text.secondary,
		fontSize: "0.75rem",
	},
}));

const StatCard = ({ label, value, hint, caption, color }) => {
	const classes = useStyles();

	return (
		<Paper className={classes.card} variant="outlined">
			<div className={classes.header}>
				<Typography className={classes.label}>{label}</Typography>
				{hint && (
					<Tooltip title={hint} arrow placement="top">
						<InfoOutlinedIcon className={classes.info} />
					</Tooltip>
				)}
			</div>
			<div>
				<Typography
					variant="h4"
					component="div"
					className={classes.value}
					style={color ? { color } : undefined}
				>
					{value}
				</Typography>
				<Typography className={classes.caption}>{caption || "\u00a0"}</Typography>
			</div>
		</Paper>
	);
};

export default StatCard;
